// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3gizd","bigColWidth":"Table_bigColWidth__3z0JY","biggerColWidth":"Table_biggerColWidth__C5X5D","row":"Table_row__3pVES","col":"Table_col__1MneO"};